import React from "react";

function LG() {
    return (
        <h1>
        This is the LG page</h1>
    );
}

export default LG